// extracted by mini-css-extract-plugin
module.exports = {"tableLoading":"TableLoading_tableLoading__2MoWK"};